export default __webpack_public_path__ + "static/AppLocation1-70007ac170339f8537a6501f30838659.png";